import { render } from "./copyright-software.vue?vue&type=template&id=2710b598&scoped=true"
import script from "./copyright-software.vue?vue&type=script&lang=js"
export * from "./copyright-software.vue?vue&type=script&lang=js"

import "./copyright.less?vue&type=style&index=0&id=2710b598&lang=less&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/NM12r8skh/0/website/official-website-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2710b598"]])

export default __exports__